import Navbar from "../../components/navbar/Navbar";
import "./About.css";
import skillsInformation from "./skills";
import GamesVideo from "../../components/games_video/Games_Video";
import MenuBar from "../../components/menuBar/MenuBar";
import Skills from "../../components/skills/Skills";
import Games from "../../components/games/Games";
import Socials from "../../components/socials/Socials";
import Footer from "../../components/footer/Footer";
import MyPhoto from "./assets/myPhoto.png";
import HeaderElement from "./assets/headerElement.png";
import headerElement2 from "./assets/headerElement2.png";
import describeElement from "./assets/describeElement.png";
import { Blue, Red, Rank, White } from "./ColorSpans";

function AddIcon({ icon }) {
  return <img src={icon} alt={icon} className="caption-icon" />;
}

function AboutPage() {
  const skills = skillsInformation;

  return (
    <div className="about-page">
      <Navbar />
      <MenuBar />
      <div className="header">
        <div className="element1">
          <AddIcon icon={HeaderElement} />
        </div>
        <div className="entry">
          <h1>
            Hi There,
            <br />
            I'm <Blue>Przemek Murawski</Blue>,
            <br />
            <Rank>
              Full Stack Web Game & Blockchain Developer
            </Rank>
          </h1>
        </div>
        <div className="element2">
          <AddIcon icon={headerElement2} />
        </div>
        <div className="photo">
          <AddIcon icon={MyPhoto} />
        </div>
      </div>

      <p className="title" id="career">
        Career
      </p>
      <div className="descriptionPage">
        <div className="description">
          <h2>
            Developer of{" "}
            <Red>Pixi.js</Red> and{" "}
            <Red>Phaser 3</Red> games. I have{" "}
            <Blue> over 5 years of experience</Blue> in game
            development. During my tenure, I have expertise in
            working with both{" "}
            <Blue>Centralized Databases (CDB)</Blue> and{" "}
            <Blue>Decentralized Databases (DDB)</Blue>.
            <br />
            <br />I developed my skills by creating freelance and <Blue>B2B</Blue> projects. I mainly created{" "}
            <Blue>Gambling</Blue>,{" "}
            <Blue>Educational</Blue>,{" "}
            <Blue>Open World</Blue> and{" "}
            <Blue>Real-time Multiplayer</Blue> games.
            <br />
            <br />
            My acquired knowledge allows me to have{" "}
            <Blue> in-depth knowledge </Blue> in games
            operation, optimization and keeps the code structure readable for
            future fixes which makes me a person who who will complete your jobs
            correctly the first time.
            <br />
            The years I have worked have also influenced my <Blue>project management</Blue> skills and working closely with graphic designers and sound designers.
            <br />
            <br />
            Additionally, I have a small background as a{" "}
            <Blue>graphic designer</Blue>, enhancing my skill
            set. I incorporate visually appealing elements into my game designs
            for immersive user experiences.
            <br />
            <br />
            As a child I played multiplayer games and was always curious about
            how they work. I was wondering why some people are good at cheating
            in games and how they both do it. When I delved into this topic, I
            wanted to create my own game and that's how my career began.
            <br />
            <br />I think <Blue>Web 3.0 </Blue>is the future
            that will take over the internet, so I'm training my skills in{" "}
            <Blue>Blockchain technology</Blue>.
            <br />I created my own <Blue>NFT</Blue> and simple{" "}
            <Blue>NFT game</Blue>.
          </h2>
        </div>
      </div>
      <div className="skillsPage">
        <div className="skills">
          <h2>
            <br />
            <strong>I’m experienced in:</strong>
            <br />
            <br /> <em>Frontend:</em>
            <br />
            <ul>
              {skills.map((skill, index) => (
                <li key={index}>
                  <i>{skill.name}</i>
                  <br />
                  {index === 6 && (
                    <White>
                      {" "}
                      <br />
                      <em>Backend:</em>
                    </White>
                  )}

                  {index === 10 && (
                    <White>
                      {" "}
                      <br />
                      <em>Blockchain:</em>
                    </White>
                  )}

                  {index === 13 && (
                    <White>
                      {" "}
                      <br />
                      <em>Mobile application development:</em>
                    </White>
                  )}

                  {index === 14 && (
                    <White>
                      {" "}
                      <br />
                      <em>Tools:</em>
                    </White>
                  )}
                </li>
              ))}
            </ul>
            <br />
            {skills.map((skill, index) => (
              <AddIcon key={index} icon={skill.icon} />
            ))}
            <br />I can also create a game for the{" "}
            <Blue>Android</Blue> platform using Apache Cordova.
          </h2>
        </div>
        <div className="describeElement">
          <AddIcon key="describe" icon={describeElement} />
        </div>
      </div>
      <Skills />
      <Games />
      <GamesVideo />
      <Socials />
      <Footer />
    </div>
  );
}

export default AboutPage;
